import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from 'gatsby';

import placeholderVideo from '../videos/wfp.mp4';
import placeholderVideoStill from '../videos/wfp-still.jpg';
import logo from '../images/wfp-logo-vertical-black-en.svg';
import logoEU from '../images/LOGO CE_Vertical_EN_NEG_PANTONE_LR.png';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'fixed',
      right: 0,
      bottom: 0,
      minWidth: '100%',
      minHeight: '100%',
    },
    bannerBg: {
      display: 'flex',
      width: '100%',
      paddingTop: '40px',
      opacity: '0.8',
    },
    title: {
      color: 'white',
      fontWeight: 'bold',
      padding: '10px',
    },
    paper: {
      backgroundColor: 'transparent',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '450px',
    },
    video: {
      height: '100%',
      minHeight: '100vh',
      objectFit: 'cover',
      width: '100%',
      opacity: 1,
    },
    parallaxChildren: {
      backgroundColor: 'transparent',
      display: 'flex',
      position: 'absolute',
      textAlign: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      height: '100%',
    },
    button: {
      color: '#00000f',
      marginTop: '20px',
      padding: '15px',
      borderRadius: '3px',
      backgroundColor: 'rgba(255,255,255,0.9)',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.7)',
      },
    },
    logos: {
      display: 'flex',
      verticalAlign: 'center',
      alignItems: 'center',
      marginBottom: '20px',
    },
    euLogo: {
      marginRight: '20px',
    },
  }),
);

const IntroVideo = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={12} className={classes.bannerBg}>
        <video
          className={classes.video}
          autoPlay
          loop
          playsInline
          preload="auto"
          muted
          poster={placeholderVideoStill}
          src={placeholderVideo}
        />
      </Grid>

      <Grid item xs={12} md={12} className={classes.parallaxChildren}>
        <div className={classes.paper}>
          <div className={classes.logos}>
            <img src={logo} className={classes.euLogo} alt="Logo" height="180px" />
            <img src={logoEU} alt="Logo" height="140px" />
          </div>
          <Typography variant="h2" className={classes.title}>
            WFP-EU 2019 Partnership Report
          </Typography>

          <Button size="large" className={classes.button} component={Link} to="/report">
            View the report
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default IntroVideo;
